// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__merriweatherItalic_545c92', '__merriweatherItalic_Fallback_545c92', s, e, r, i, f","fontStyle":"normal"},"className":"__className_545c92"};